import {html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';

export const NAV_LABEL_ELEMENT_TAG = 'fly-nav-label';

/**
 * NavLabel -- Description here
 */
@customElement(NAV_LABEL_ELEMENT_TAG)
export default class NavLabel extends FlywheelComponent {
  @property({type: Boolean})
  separator = false;

  static get styles() {
    return [styles];
  }

  render() {
    return html`
      ${this.separator ? html`<hr />` : ''}
      <div class="fly-nav-label">
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'fly-nav-label': NavLabel;
  }
}
